import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { AppState } from '../../../store/store';

import './Nav.scss';

export const NavItemsData = [
  {
    path: '/category',
    name: 'Category',
  },
  {
    path: '/',
    name: 'Home',
  },
  {
    path: '/events',
    name: 'Events',
  },
];

export const Nav = (): ReactElement => {
  const { t } = useTranslation();
  const history = useHistory();

  const curPath = useSelector(
    (state: AppState) => state.router.location.pathname,
  );

  const handleNavClick = (event: React.MouseEvent, itemPath: string) => {
    event.preventDefault();
    history.push(itemPath);
  };

  return (
    <ul className="app-bar__nav">
      {NavItemsData.map((item) => (
        <Link
          key={item.name}
          className={`app-bar__nav-link${
            curPath === item.path ? '--selected' : ''
          }`}
          to={item.path}
          onClick={(event) => handleNavClick(event, item.path)}
        >
          {t(item.name)}
        </Link>
      ))}
    </ul>
  );
};
